import { defineStore } from 'pinia';
import LocationGroup from '../entities/location-group';

export const useLocationGroupsStore = defineStore('locationGroupsStore', {
	state: () => ({
		loading: false,
		groups: [],
		originalGroups: [],
	}),
	actions: {
		async fetchGroups() {
			this.loading = true;
			try {
				const { data } = await LocationGroup.fetchGroups({
					per_page: 1000,
					sort_direction: 'asc',
				});
				this.groups = data;
				this.originalGroups = data.map(
					(group) => new LocationGroup(JSON.parse(JSON.stringify(group))),
				);
			} finally {
				this.loading = false;
			}
		},
		addNewGroup() {
			const group = new LocationGroup({
				id: `location-${Math.random()}`,
				isLocal: true,
				name: '',
			});
			this.groups.push(group);
		},
		async removeGroup(idx) {
			const group = this.groups[idx];
			await group.remove();
			this.groups.splice(idx, 1);
		},
	},
});
